import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DiscountCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {
  types = {
    postad: 'postad',
    vanguardSeeker: 'vanguard-seeker',
    buyResume: 'buy-resume'
  };

  constructor(private http: HttpClient) { }

  async tryBest(type: string, code?: string) {
    return this.http.get<any>(environment.app.apiUrl + `discount/best/${type}/${(code ? `${code}` : '')}`, { params: { cb: Math.random() } }).toPromise();
  }

  async search(criteria?: DiscountCriteria, from: number = 0, limit: number = 100) {
    return this.http.post<any>(environment.app.apiUrl + `discount/search/${from}/${limit}`, criteria || {}).toPromise();
  }

  async save(discount: any) {
    return this.http.post(environment.app.apiUrl + 'discount/save', discount).toPromise();
  }

  async delete(id: string) {
    return this.http.post(environment.app.apiUrl + 'discount/delete/' + id, null).toPromise();
  }
}
